import classNames from 'classnames';
import propTypes from 'prop-types';
import React from 'react';

import TextInput from 'common/TextInput';
import { getMessage } from 'util/locale';

const baseString = 'vra-script-name';
const ScriptName = ({
  dataTestId=baseString,
  disabled,
  displayScriptName,
  forceUpdateKey=baseString, // uncontrolled component, but we may want to force update from state, allow passing a key
  label=getMessage('label-text__rx-name'),
  onChange,
  validationResult
}) => {
  const classString = classNames({
    [`${baseString}`]: true
  });

  return (
    <section className={classString}>
      <div className={`${baseString}__input-wrapper`}>
        <TextInput
          dataTestId={dataTestId}
          defaultValue={displayScriptName}
          disabled={disabled}
          key={forceUpdateKey}
          label={label}
          onBlur={onChange}
          showReset={false}
          validationResult={validationResult}
        />
      </div>
    </section>
  );
};

ScriptName.propTypes = {
  dataTestId: propTypes.string,
  disabled: propTypes.bool,
  displayScriptName: propTypes.string,
  forceUpdateKey: propTypes.string,
  label: propTypes.string,
  onChange: propTypes.func.isRequired,
  validationResult: propTypes.object
};

export default ScriptName;
